import { useDataLayerAction } from '../TagContext'
import { useEffect } from 'react'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'

export const usePdpTracking = (
    product?: Maybe<ProductInterface>,
    isValidating?: boolean
): void => {
    const dataLayerAction = useDataLayerAction()
    useEffect(() => {
        if (product && !isValidating) {
            dataLayerAction({
                type: 'PDP',
                data: product
            })
        }
    }, [dataLayerAction, product])
}
